import React from 'react'

import { useWalkthroughSteps } from '@/components/flows/WalkthroughFlow/hooks/useWalkthroughSteps'

interface Props {
  imageUrl: string
  imageAlt?: string
  text: React.ReactNode
}

const ImageWithText: React.FC<Props> = ({ imageUrl, imageAlt, text }) => {
  const { currentStep } = useWalkthroughSteps()

  return (
    <div className="border bg-white" style={{ borderRadius: '5px' }}>
      <img
        src={imageUrl}
        alt={imageAlt || currentStep?.label}
        className="max-w-full border-b"
      />

      <div
        className="text-md font-light"
        css={{
          strong: {
            fontWeight: '400',
          },
          lineHeight: 1.7,
          padding: '20px 24px 24px',
          'p:last-of-type': {
            marginBottom: '0',
          },
        }}
      >
        {text}
      </div>
    </div>
  )
}
export default ImageWithText
